import { render, staticRenderFns } from "./AssignmentsGrid.vue?vue&type=template&id=5435c59d&"
import script from "./AssignmentsGrid.vue?vue&type=script&lang=js&"
export * from "./AssignmentsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5435c59d')) {
      api.createRecord('5435c59d', component.options)
    } else {
      api.reload('5435c59d', component.options)
    }
    module.hot.accept("./AssignmentsGrid.vue?vue&type=template&id=5435c59d&", function () {
      api.rerender('5435c59d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/AssignmentsGrid.vue"
export default component.exports